import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { RouterLink } from "@angular/router";
import { AdaptFeatureModule } from "@common/feature/feature.module";
import { AdaptShellModule } from "@common/shell/shell.module";
import { AdaptToolbarModule } from "@common/shell/toolbar/toolbar.module";
import { AdaptCommonDialogModule } from "@common/ux/adapt-common-dialog/adapt-common-dialog.module";
import { AdaptButtonModule } from "@common/ux/button/button.module";
import { AdaptCollapsibleDashboardElementModule } from "@common/ux/collapsible-dashboard-element/collapsible-dashboard-element.module";
import { AdaptDateModule } from "@common/ux/date/date.module";
import { AdaptHtmlEditorModule } from "@common/ux/html-editor/html-editor.module";
import { AdaptLayoutModule } from "@common/ux/layout/layout.module";
import { AdaptLoadingSpinnerModule } from "@common/ux/loading-spinner/loading-spinner.module";
import { AdaptMenuModule } from "@common/ux/menu/menu.module";
import { AdaptRerenderModule } from "@common/ux/rerender/rerender.module";
import { AdaptStyledDashboardElementModule } from "@common/ux/styled-dashboard-element/styled-dashboard-element.module";
import { AdaptTooltipModule } from "@common/ux/tooltip.directive/tooltip.module";
import { AdaptTwoColumnModule } from "@common/ux/two-column/two-column.module";
import { AdaptUniversalDashboardElementModule } from "@common/ux/universal-dashboard-element/universal-dashboard-element.module";
import { AdaptActivitiesSharedModule } from "@org-common/lib/activities/activities-shared.module";
import { provideActivityHandler } from "@org-common/lib/activities/activity-handler";
import { ActionActivityHandler } from "@org-common/lib/activities/activity-handlers/action-activity-handler";
import { CulturalActivityHandler } from "@org-common/lib/activities/activity-handlers/cultural-activity-handler";
import { MeetingActivityHandler } from "@org-common/lib/activities/activity-handlers/meeting-activity-handler";
import { ObjectiveActivityHandler } from "@org-common/lib/activities/activity-handlers/objective-activity-handler";
import { ActivityPageContentComponent } from "@org-common/lib/activities/activity-page-content/activity-page-content.component";
import { PersonalMeetingsActivitySectionComponent } from "@org-common/lib/activities/personal-meetings-activity-section/personal-meetings-activity-section.component";
import { PersonalObjectivesActivitySectionComponent } from "@org-common/lib/activities/personal-objectives-activity-section/personal-objectives-activity-section.component";
import { PersonalWorkActivitySectionComponent } from "@org-common/lib/activities/personal-work-activity-section/personal-work-activity-section.component";
import { RescheduleActivityDialogComponent } from "@org-common/lib/activities/reschedule-activity-dialog/reschedule-activity-dialog.component";
import { AdaptAuthorisationModule } from "@org-common/lib/authorisation/authorisation.module";
import { AdaptDirectorySharedModule } from "@org-common/lib/directory-shared/directory-shared.module";
import { AdaptKanbanModule } from "@org-common/lib/kanban/kanban.module";
import { AdaptCommonMeetingsModule } from "@org-common/lib/meetings/common-meetings.module";
import { AdaptMeetingsSharedModule } from "@org-common/lib/meetings/meetings-shared.module";
import { AdaptObjectivesModule } from "@org-common/lib/objectives/objectives.module";
import { AdaptPeerCatchupModule } from "@org-common/lib/peer-catchup/peer-catchup.module";
import { AdaptTeamDashboardSharedModule } from "@org-common/lib/teams/team-dashboard-shared/team-dashboard-shared.module";
import { AdaptWorkflowModule } from "@org-common/lib/workflow/workflow.module";
import { DxDateBoxModule, DxLoadPanelModule, DxPopoverModule, DxSchedulerModule, DxSelectBoxModule, DxTagBoxModule } from "devextreme-angular";
import { AlertComponent } from "ngx-bootstrap/alert";
import { ActivityCalendarComponent } from "./activity-calendar/activity-calendar.component";
import { ActivityCardComponent } from "./activity-card/activity-card.component";
import { ActivityFilterComponent } from "./activity-filter/activity-filter.component";
import { ActivitySectionCollapsibleComponent } from "./activity-section-collapsible/activity-section-collapsible.component";
import { DeleteActivityDialogComponent } from "./delete-activity-dialog/delete-activity-dialog.component";


@NgModule({
    declarations: [
        ActivityPageContentComponent,
        ActivityCardComponent,
        RescheduleActivityDialogComponent,
        ActivitySectionCollapsibleComponent,
        PersonalWorkActivitySectionComponent,
        PersonalObjectivesActivitySectionComponent,
        PersonalMeetingsActivitySectionComponent,
        ActivityFilterComponent,
        DeleteActivityDialogComponent,
        ActivityCalendarComponent,
    ],
    exports: [
        ActivityPageContentComponent,
        PersonalWorkActivitySectionComponent,
        PersonalObjectivesActivitySectionComponent,
        PersonalMeetingsActivitySectionComponent,
        ActivityCardComponent,
    ],
    imports: [
        CommonModule,
        RouterLink,
        AdaptActivitiesSharedModule,
        AdaptAuthorisationModule,
        AdaptButtonModule,
        AdaptCollapsibleDashboardElementModule,
        AdaptCommonDialogModule,
        AdaptCommonMeetingsModule,
        AdaptDateModule,
        AdaptDirectorySharedModule,
        AdaptFeatureModule,
        AdaptHtmlEditorModule,
        AdaptKanbanModule,
        AdaptLayoutModule,
        AdaptLoadingSpinnerModule,
        AdaptMeetingsSharedModule,
        AdaptMenuModule,
        AdaptObjectivesModule,
        AdaptPeerCatchupModule,
        AdaptRerenderModule,
        AdaptShellModule,
        AdaptStyledDashboardElementModule,
        AdaptTeamDashboardSharedModule,
        AdaptToolbarModule,
        AdaptTooltipModule,
        AdaptTwoColumnModule,
        AdaptUniversalDashboardElementModule,
        AdaptWorkflowModule,
        DxDateBoxModule,
        DxLoadPanelModule,
        DxPopoverModule,
        DxSchedulerModule,
        DxSelectBoxModule,
        DxTagBoxModule,
        AlertComponent,
    ],
    providers: [
        provideActivityHandler(CulturalActivityHandler),
        provideActivityHandler(ActionActivityHandler),
        provideActivityHandler(MeetingActivityHandler),
        provideActivityHandler(ObjectiveActivityHandler),
    ],
})
export class AdaptActivitiesModule {}
